import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiCall } from '../../api/apiConfig';

export const detectAIText = createAsyncThunk(
    'aiTextDetector/detectAIText',
    async ({ text, filters }, { rejectWithValue }) => {
        try {
            const response = await apiCall('/detect-ai-text', 'POST', { text, filters });
            // Check if the response contains an error
            if (response.error) {
                return rejectWithValue(response.message);
            }
            return response;
        } catch (error) {
            return rejectWithValue('Error analyzing text');
        }
    }
);

const aiTextDetectorSlice = createSlice({
    name: 'detectAIText',
    initialState: {
        aitext: [], // Stores detected AI text results
        loading: false, // Indicates ongoing API call
        error: null, // Stores error messages
    },
    reducers: {
        updateAIText: (state, action) => {
            state.aitext = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(detectAIText.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(detectAIText.fulfilled, (state, action) => {
                state.loading = false;
                state.aitext = Array.isArray(action.payload?.results) ? action.payload.results : [];
            })
            .addCase(detectAIText.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'An unexpected error occurred';
            });
    },
});

// Reusable selectors
export const selectAIText = (state) => state.aiTextDetectorSlice.aitext;
export const selectLoading = (state) => state.aiTextDetectorSlice.loading;
export const selectError = (state) => state.aiTextDetectorSlice.error;

export const { updateAIText } = aiTextDetectorSlice.actions;
export default aiTextDetectorSlice.reducer;
